import { memo } from 'react';

import { produce } from 'immer';
import { usePinnedColumnsContext, Show, For } from 'shared';

import { PlanningSprintModel } from 'features/planning';
import { SPRINT_STATES } from 'features/sprint/config';
import { useSprintsQuery } from 'features/sprint/hooks';

import { PlanningActiveSprint } from './ActiveSprint';
import { PlanningFinishedSprint } from './FinishedSprint';

export const PlanningActiveFinishedSprints = memo(
  ({ pinned }: { pinned: boolean }) => {
    const { pinnedColumns } = usePinnedColumnsContext();
    const { data: activeFinishedSprintsData } =
      useSprintsQuery<PlanningSprintModel[]>();

    const filteredSprints = produce(activeFinishedSprintsData, (draft) => {
      draft?.reverse();
    })?.filter((sprint) => {
      return pinned
        ? pinnedColumns.has(sprint.sprintId)
        : !pinnedColumns.has(sprint.sprintId);
    });

    return (
      <For each={filteredSprints!}>
        {(
          {
            sprintId,
            title,
            sprintOutcomes,
            challenges,
            coachingTools,
            formattedDate,
            weeksCount,
            sprintRestartedMetaData,
            finished,
            startDate,
            endDate,
            state,
          },
          index: number
        ) => {
          return (
            <Show
              key={sprintId}
              when={state === SPRINT_STATES.ACTIVE}
              fallback={
                <>
                  <PlanningFinishedSprint
                    sprintId={sprintId}
                    sprintTitle={title}
                    sprintOutcomes={sprintOutcomes}
                    challenges={challenges}
                    coachingTools={coachingTools}
                    sprintFormattedDate={formattedDate}
                    shouldScrollIntoView={index === filteredSprints!.length - 1}
                    sprintIndex={index}
                    sprintWeeksCount={weeksCount}
                    sprintRestartedMetaData={sprintRestartedMetaData}
                    sprintFinished={finished}
                    sprintStartDate={startDate}
                    sprintEndDate={endDate}
                  />
                </>
              }
            >
              <PlanningActiveSprint
                key={challenges.length}
                sprintId={sprintId}
                sprintTitle={title}
                sprintOutcomes={sprintOutcomes}
                challenges={challenges}
                coachingTools={coachingTools}
                sprintFormattedDate={formattedDate}
                sprintIndex={index}
                sprintWeeksCount={weeksCount}
                sprintRestartedMetaData={sprintRestartedMetaData}
                sprintStartDate={startDate}
                sprintEndDate={endDate}
              />
            </Show>
          );
        }}
      </For>
    );
  }
);
